import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ------------ Types -------------
export interface PersonInfo {
  shortName: string;
  tin: string;
}

export interface UserData {
  person: PersonInfo;
  // extend with other user related fields if needed
}

export interface AuthState {
  isAuth: boolean;
  isRegistered: boolean;
  key: any | null;
  userName: string | null;
  userTin: string | null;
  userData: UserData | null;
  token: string | null;
}

// ------------ Initial state -------------
const initialState: AuthState = {
  isAuth: false,
  isRegistered: true,
  key: null,
  userName: null,
  userTin: null,
  userData: null,
  token: null,
};

export const { actions: authActions, reducer: authReducer } = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, { payload }: PayloadAction<{ key: any; userData: UserData; token: string; tin?: string }>) {
      const { key, userData, token, tin } = payload;
      // Sanitize Date objects inside `key` to ISO strings so that Redux state remains serializable
      const sanitizedKey = JSON.parse(JSON.stringify(key));
      localStorage.setItem('token', JSON.stringify(token));

      state.isAuth = true;
      state.key = sanitizedKey;
      state.token = token;
      state.userName = sanitizedKey.CN;
      state.userTin = tin ?? sanitizedKey.TIN;
      state.userData = userData;
      state.isRegistered = true;
    },

    logout: () => {
      localStorage.removeItem('token');
      return initialState as AuthState;
    },
    updateRegistration(state, { payload }: PayloadAction<boolean>) {
      state.isRegistered = payload;
    },
  },
});

export default authReducer;
